module.exports = __webpack_public_path__ + "static/media/event.a7730a7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/event.png
// module id = 793
// module chunks = 68